import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

type MediaEditAccordionProps = {
  defaultExpanded?: boolean;
  title: string;
  children: ReactNode;
};

export const MediaEditAccordion = ({
  defaultExpanded = false,
  title,
  children,
}: MediaEditAccordionProps) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={title}>
        <Typography variant="subtitle2">{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.down('md')]: {
    display: 'block',
    boxShadow: theme.customShadows.card,

    '&.Mui-expanded': {
      boxShadow: theme.customShadows.card,
    },
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
